import { Component } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService, NotificationsService,
    PriceService,
    PricePoint
} from '@varsity/services';
import { BaseComponent } from '@varsity/components';
import { PopoverController, ToastController, NavParams, ViewController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the DisplayMessageComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'price-selection',
    templateUrl: 'price-selection.html'
})
export class PriceSelectionComponent extends BaseComponent {
    header: string;
    icon: string;
    content: string[];
    footer: string;
    prices: PricePoint[];
    ticketCount: number;

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected viewCtrl: ViewController,
        protected navParams: NavParams,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "PriceSelectionComponent"
        );
    }

    ngOnInit() {
        let params = this.navParams.get('params') as PriceSelectionParams;

        this.icon = params.icon;
        this.header = params.header;
        this.content = params.content;
        this.footer = params.footer;
        this.prices = params.prices;
        this.ticketCount = params.ticketCount;
    }

    buttonClicked(button: 'finished' | 'cancel') {
        const newTotal = this.prices.map(p => p.OrderQuantity).reduce((previous, current) => {
            return previous + current;
        }, 0);

        if (button === 'finished' && newTotal != this.ticketCount) {
            this.showNotification(`Please select prices for all tickets. You still have ${this.ticketCount - newTotal} tickets remaining`, undefined, undefined, "error");
            return;
        } else {
            let result = new PriceSelectionResult();
            result.result = button;
            this.viewCtrl.dismiss(result);
        }
    }

    getTicketsLeft(): number {
        const newTotal = this.prices.map(p => p.OrderQuantity).reduce((previous, current) => {
            return previous + current;
        }, 0);

        return this.ticketCount - newTotal;
    }

    removeTicket(ticketObject: PricePoint): void {
        let delta = 0;
        if (ticketObject.OrderQuantity > ticketObject.MinWebTickets) {
            ticketObject.OrderQuantity = ticketObject.OrderQuantity - ticketObject.IncrWebTickets;
            delta = ticketObject.IncrWebTickets;
        } else if (ticketObject.OrderQuantity == ticketObject.MinWebTickets) {
            ticketObject.OrderQuantity = 0;
            delta = ticketObject.MinWebTickets;
        }
    }

    addTicket(ticketObject: PricePoint): void {
        let delta = 0;
        if (ticketObject.OrderQuantity == 0) {
            ticketObject.OrderQuantity = ticketObject.MinWebTickets;
            delta = ticketObject.MinWebTickets;
        } else if (ticketObject.OrderQuantity + ticketObject.IncrWebTickets <= ticketObject.MaxWebTickets && this.canPlus(ticketObject)) {
            ticketObject.OrderQuantity = ticketObject.OrderQuantity + ticketObject.IncrWebTickets;
            delta = ticketObject.IncrWebTickets;
        } else {
            this.showNotification('You can add more tickets only if you select them from stadium layout.', undefined, undefined, "warning");
        }
    }

    canPlus(ticketObject: PricePoint) {
        let delta = 0;
        if (ticketObject.OrderQuantity == 0) {
            delta = ticketObject.MinWebTickets;
        } else if (ticketObject.OrderQuantity + ticketObject.IncrWebTickets <= ticketObject.MaxWebTickets &&
            ticketObject.OrderQuantity + ticketObject.IncrWebTickets <= ticketObject.AvaiableCount) {
            delta = ticketObject.IncrWebTickets;
        }

        const newTotal = this.prices.map(p => p.OrderQuantity).reduce((previous, current) => {
            return previous + current;
        }, 0);

        return newTotal < this.ticketCount;
    }
}

export class PriceSelectionParams {
    icon: string;
    header: string;
    content: string[];
    footer: string;
    prices: PricePoint[];
    ticketCount: number;
}

export class PriceSelectionResult {
    result: 'finished' | 'cancel'
}



// WEBPACK FOOTER //
// ./src/components/price-selection/price-selection.ts